/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import NextImage from '@/components/NextImage';
import MobileBlogMenuNavigationStyles from '../MobileBlogMenuNavigation.module.scss';
import { CMSLink } from '@/features/contentstack/components/CMSLink/CMSLink';
import { useLabels } from '@/hooks/useLabels';
import { Icon, View, Text } from '@az/starc-ui';
import { ArrowRight } from '@az/starc-ui-icons';
import { type FormattedContentStackBlogMenuNavigation } from '@/features/contentstack/interface/models';

const labelMap = {
  featuredSectionHeading: 'label_BLOG_FeaturedSectionHeading',
};

type FeaturedSection = {
  featuredLinkContent: NonNullable<
    FormattedContentStackBlogMenuNavigation['menu_navigation']
  >[number]['feature_link_content'];
  handleCloseModal: () => void;
};

export const FeaturedSection = ({
  featuredLinkContent,
  handleCloseModal,
}: FeaturedSection & { handleCloseModal: () => void }) => {
  const labels = useLabels(labelMap);

  return (
    <View
      direction="column"
      maxWidth="200px"
      padding={{ s: 2 }}
      className={MobileBlogMenuNavigationStyles.featuredSection}
    >
      <Text
        size="112"
        weight="bold"
        className={MobileBlogMenuNavigationStyles.featuredContentHeading}
      >
        {labels.featuredSectionHeading}
      </Text>
      {featuredLinkContent?.image_url && (
        <NextImage
          src={featuredLinkContent.image_url}
          width={184}
          height={123}
          alt={featuredLinkContent.heading}
        />
      )}
      <View direction="column" className={MobileBlogMenuNavigationStyles.featuredContent}>
        <Text size="112" weight="bold" className={MobileBlogMenuNavigationStyles.heading}>
          {featuredLinkContent?.heading}
        </Text>
        <Text weight="regular" className={MobileBlogMenuNavigationStyles.subHeading}>
          {featuredLinkContent?.sub_heading}
        </Text>
      </View>
      {featuredLinkContent?.cta && (
        <View direction="row" align="center" className={MobileBlogMenuNavigationStyles.cta}>
          <CMSLink to={featuredLinkContent.cta.href} onClick={handleCloseModal}>
            <Text textCase="uppercase" weight="medium" size="087" fontFamily="headline">
              {featuredLinkContent.cta.title}
            </Text>
          </CMSLink>
          <Icon size={6} color="accent" svg={ArrowRight} />
        </View>
      )}
    </View>
  );
};
